export default __webpack_public_path__ + "static/media/demoApplicationImg.3e7dc1c6.png";